// TODO: Replace with @weave/schema-gen-ts import once phone audits proto package is published

// ----- Object Types -----
export type ObjectType = string;
export const ObjectTypeCallBlocking: ObjectType = 'CALL_BLOCKING';
export const ObjectTypeCallRecording: ObjectType = 'CALL_RECORDING';
export const ObjectTypeHoldMusic: ObjectType = 'HOLD_MUSIC';

export function GetObjectTypeValues(): string[] {
  return [ObjectTypeCallBlocking, ObjectTypeCallRecording, ObjectTypeHoldMusic];
}

// ----- Action Types -----
export type ActionType = string;
export const ActionTypeCreate: ActionType = 'CREATE';
export const ActionTypeUpdate: ActionType = 'UPDATE';
export const ActionTypeDelete: ActionType = 'DELETE';

export function GetActionTypeValues(): string[] {
  return [ActionTypeCreate, ActionTypeUpdate, ActionTypeDelete];
}

// ----- Actor Types -----
export type ActorType = string;
export const ActorTypeUser: ActorType = 'USER';
export const ActorTypeSystem: ActorType = 'SYSTEM';
export const ActorTypeWeave: ActorType = 'WEAVE';

export function GetActorTypeValues(): string[] {
  return [ActorTypeUser, ActorTypeSystem, ActorTypeWeave];
}

// ----- Change Types -----
export type ChangeType = string;
export const ChangeTypeBlockNumber: ChangeType = 'BLOCK_NUMBER';
export const ChangeTypeUnblockNumber: ChangeType = 'UNBLOCK_NUMBER';
export const ChangeTypeSetInbound: ChangeType = 'SET_INBOUND';
export const ChangeTypeSetOutbound: ChangeType = 'SET_OUTBOUND';
export const ChangeTypeSetAll: ChangeType = 'SET_ALL';
export const ChangeTypeSetDisabled: ChangeType = 'SET_DISABLED';
export const ChangeTypeUpdateHoldMusic: ChangeType = 'UPDATE_HOLD_MUSIC';

export function GetChangeTypeValues(): string[] {
  return [
    ChangeTypeBlockNumber,
    ChangeTypeUnblockNumber,
    ChangeTypeSetInbound,
    ChangeTypeSetOutbound,
    ChangeTypeSetAll,
    ChangeTypeSetDisabled,
    ChangeTypeUpdateHoldMusic,
  ];
}

// ----- Request / Response -----
export type SearchAuditEventsRequest = {
  tenantId?: string;
  objectTypes?: string[];
  userIds?: string[];
  actions?: string[];
  objectId?: string;
  searchInput?: string;
  timeRange?: TimeRange;
  pageSize?: number;
  pageToken?: string;
};

export type SearchAuditEventsResponse = {
  auditEvents?: AuditEvent[];
  nextPageToken?: string;
  prevPageToken?: string;
  trackingStartTime?: string;
};

export type TimeRange = {
  startTime?: string;
  endTime?: string;
};

// ----- Domain Models -----
export type AuditEvent = {
  id?: string;
  changeGroupId?: string;
  tenantId?: string;
  objectType?: string;
  action?: string;
  objectName?: string;
  objectId?: string;
  actor?: AuditActor;
  changes?: AuditChange[];
  createTime?: string;
};

export type AuditActor = {
  userId?: string;
  userName?: string;
  email?: string;
  actorType?: string;
};

export type AuditChange = {
  type?: string;
} & (
  | { blockNumber: BlockNumberContext }
  | { callRecording: CallRecordingContext }
  | { updateHoldMusic: UpdateHoldMusicContext }
);

export type BlockNumberContext = {
  phoneNumber?: string;
};

export type CallRecordingContext = Record<string, never>;

export type UpdateHoldMusicContext = {
  locations?: HoldMusicLocation[];
};

export type HoldMusicLocation = {
  mediaItemId?: string;
  mediaItemName?: string;
  locationId?: string;
  locationName?: string;
};
